module.exports = {
  "asset": "Asset",
  "assets": "Assets",
  "section": "Section",
  "sections": "Sections",
  "seek": "Seek",
  "hub": "Hub",
  "stream": "Stream",
  "streams": "Streams",
  "group": "Group",
  "groups": "Groups",
  "conversations": "Conversations",
  "conversation": "Conversation",
  "collection": "Collection",
  "collections": "Collections",
  "contact": "Contact",
  "contacts": "Contacts",
  "contact_lists": "Contact Lists",
  "collection_types": {
    "carousel": "Carousel",
    "metro": "Metro",
    "deal_room": "Deal Room"
  },
  "asset_viewers": {
    "list_viewer": "List Viewer",
    "immerse_viewer": "Immerse Viewer",
    "gallery_viewer": "Gallery Viewer"
  },
  "generate_link": "Generate Link",
  "link": "Link",
  "quicksend": "QuickSend"
}